import { useEffect, useState } from "react"
import { useScroll } from "framer-motion"

// eslint-disable-next-line @typescript-eslint/no-unused-vars
interface useScrollTriggerParameters {
  wrapperRef: any
  threshold: number
}

interface useScrollTriggerReturnObject {
  isTriggered: boolean
}

const useScrollTrigger: (
  useScrollTriggerParameters
) => useScrollTriggerReturnObject = ({ wrapperRef, threshold }) => {
  const [isTriggered, setIsTriggered] = useState(false)
  const { scrollY } = useScroll()

  const scrollYChangeHandler = y => {
    if (!wrapperRef.current) return
    const wrapperEl = wrapperRef.current
    const top = window.scrollY + wrapperEl.getBoundingClientRect().top
    const nextIsTriggered =
      y + window.innerHeight > top + wrapperEl.clientHeight * (1 - threshold) &&
      y < top + wrapperEl.clientHeight * threshold
    if (isTriggered !== nextIsTriggered) {
      setIsTriggered(nextIsTriggered)
    }
  }

  useEffect(() => scrollYChangeHandler(window.scrollY), [])
  useEffect(
    () => scrollY.onChange(scrollYChangeHandler),
    [isTriggered, threshold]
  )

  return {
    isTriggered,
  }
}

export default useScrollTrigger
